import React from 'react';
import { Card } from '../components/ui';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from '../hooks/useTranslation';
import { ArrowBack, Shield, Download, Lock, Block, Edit, Analytics, BusinessCenter, Gavel, CheckCircle, Cancel, Security, BarChart, Description } from '../mui-icons';
import './TermsPage.css';

const TermsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const pdfPath = require('../assets/pdf/TERMO DE USO DO APLICATIVO PERSONAL NUTRI.pdf');

  return (
    <div className="terms-page surface-marketing">
      <Header />

      {/* Header Verde */}
      <section className="terms-header-section">
        <div className="container">
          <div className="terms-header-content">
            <Description sx={{ fontSize: 60 }} />
            <h1 className="terms-main-title">{t('terms.hero.title')}</h1>
            <p className="terms-main-subtitle">
              {t('terms.hero.subtitle')}
            </p>
          </div>
        </div>
      </section>

      <div className="container terms-container">
        {/* Info Card */}
        <section className="terms-info-card pn-card pn-card--marketing">
          <div className="terms-info-icon">
            <Description sx={{ fontSize: 40 }} />
          </div>
          <div className="terms-info-text">
            <h2 className="terms-info-title">{t('terms.info.title')}</h2>
            <p className="terms-info-description">
              {t('terms.info.description')}
            </p>
          </div>
        </section>

        {/* PDF Viewer */}
        <section className="pdf-viewer-section">
          <div className="pdf-header">
            <h2 className="pdf-title">{t('terms.pdf.title')}</h2>
            <a 
              href={pdfPath} 
              download="Termo_de_Uso_PersonalNutri.pdf"
              className="download-button"
            >
              <Download />
              {t('terms.pdf.download')}
            </a>
          </div>

          <div className="pdf-viewer-container">
            <iframe 
              src={`${pdfPath}#toolbar=1&navpanes=1&scrollbar=1&view=FitH`}
              title="Termos de Uso"
              className="pdf-iframe"
            />
          </div>

          <div className="pdf-fallback">
            <p>{t('terms.pdf.fallback')}</p>
            <a 
              href={pdfPath} 
              download="Termo_de_Uso_PersonalNutri.pdf"
              className="download-link"
            >
              {t('terms.pdf.fallbackLink')}
            </a>
          </div>
        </section>

        {/* Highlights Section */}
        <section className="terms-highlights">
          <h2 className="highlights-title">{t('terms.highlights.title')}</h2>
          <div className="highlights-grid">
            <div className="highlight-card pn-card pn-card--marketing">
              <h3 className="highlight-title">
                <CheckCircle sx={{ fontSize: 20, marginRight: '8px', verticalAlign: 'middle', color: 'var(--primary-green)' }} />
                {t('terms.highlights.acceptance.title')}
              </h3>
              <p className="highlight-text">
                {t('terms.highlights.acceptance.description')}
              </p>
            </div>

            <div className="highlight-card pn-card pn-card--marketing">
              <h3 className="highlight-title">
                <Security sx={{ fontSize: 20, marginRight: '8px', verticalAlign: 'middle', color: 'var(--primary-green)' }} />
                {t('terms.highlights.responsibility.title')}
              </h3>
              <p className="highlight-text">
                {t('terms.highlights.responsibility.description')}
              </p>
            </div>

            <div className="highlight-card pn-card pn-card--marketing">
              <h3 className="highlight-title">
                <Block sx={{ fontSize: 20, marginRight: '8px', verticalAlign: 'middle', color: 'var(--primary-green)' }} />
                {t('terms.highlights.prohibited.title')}
              </h3>
              <p className="highlight-text">
                {t('terms.highlights.prohibited.description')}
              </p>
            </div>

            <div className="highlight-card pn-card pn-card--marketing">
              <h3 className="highlight-title">
                <Gavel sx={{ fontSize: 20, marginRight: '8px', verticalAlign: 'middle', color: 'var(--primary-green)' }} />
                {t('terms.highlights.legislation.title')}
              </h3>
              <p className="highlight-text">
                {t('terms.highlights.legislation.description')}
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="terms-contact">
          <h3 className="terms-contact-title">{t('terms.contact.title')}</h3>
          <p className="terms-contact-text">
            {t('terms.contact.text')}
          </p>
          <a href="mailto:contato@personalnutri.app" className="contact-email-button">
            {t('terms.contact.button')}
          </a>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;

